import { addendumRequestsTyped } from "@/api/(requests)/addendumTyped";
import type { AdditionalAddendumContentAdvancedCare, UUID } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

export type CreateNoteAddendumVariables = {
  addendum: string;
  // only ACAA allows additionalContent currently
  additionalContent?: AdditionalAddendumContentAdvancedCare;
  credentials: string | undefined;
  noteId: UUID;
  patientId: UUID;
  signature: string | undefined;
};

export function createNoteAddendum({
  addendum,
  additionalContent,
  credentials,
  noteId,
  patientId,
  signature,
}: CreateNoteAddendumVariables) {
  return addendumRequestsTyped.create_note_addendum({
    body: {
      addendum,
      additional_content: additionalContent,
      credentials,
      note_id: noteId,
      signature,
      timestamp: dayjs().unix(),
    },
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
